function DotIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" className="min-w-[12px]">
      <path fill="none" d="M24 24H0V0h24v24z" />
      <circle fill="currentColor" cx="12" cy="12" r="8" />
    </svg>
  );
}
export default DotIcon;
